<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-04-08',
        major: [],
        excepts: [],
        items: [


          // [NOTE] みらいのプリチケバッグ
          // ================================================================================

          item({
            collection  : 'PriTicketBag_Mirai',
            id          : 'AM-111',
            rare        : 'R',
            name        : 'デニムリボンテディベアピンクワンピ',
            imgUrl      : '/images/items/AM-111.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTicketBag_Mirai',
            id          : 'AM-112',
            rare        : 'R',
            name        : 'デニムリボンイエローパンプス',
            imgUrl      : '/images/items/AM-112.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            aggregation : 'AM-111',
          }),
          item({
            collection  : 'PriTicketBag_Mirai',
            rare        : 'R',
          }),
          item({
            collection  : 'PriTicketBag_Mirai',
            rare        : 'R',
          }),


          // [NOTE] プリ☆チャンファイル だいあ＆ミラクル☆キラッツ
          // ================================================================================

          item({
            collection  : 'PrichanFile_Daia_Kirats',
            id          : 'AM-113',
            rare        : 'R',
            name        : 'ゆるふわラブリーラベンダーワンピ',
            imgUrl      : '/images/items/AM-113.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 2 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリ☆チャンファイル リングマリィ
          // ================================================================================

          item({
            collection  : 'PrichanFile_RingMarry',
            id          : 'AM-187',
            rare        : 'R',
            name        : 'ラベンダーセットアップ',
            imgUrl      : '/images/items/AM-187.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 2 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrichanFile_RingMarry',
            rare        : 'R',
          }),
          item({
            collection  : 'PrichanFile_RingMarry',
            rare        : 'R',
          }),
          item({
            collection  : 'PrichanFile_RingMarry',
            rare        : 'R',
          }),


          // [NOTE] プリ☆チャンファイル オールアイドル
          // ================================================================================

          item({
            collection  : 'PrichanFile_AllIdol',
            id          : 'AM-279',
            rare        : 'R',
            name        : 'クーリッシュブルゾン＆イエローロンＴ',
            imgUrl      : '/images/items/AM-279.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrichanFile_AllIdol',
            rare        : 'R',
          }),
          item({
            collection  : 'PrichanFile_AllIdol',
            rare        : 'R',
          }),
          item({
            collection  : 'PrichanFile_AllIdol',
            rare        : 'R',
          }),



          // [NOTE] プリチケケース
          // ================================================================================

          item({
            collection  : 'PriTickeCase',
            id          : 'AM-114',
            rare        : 'R',
            name        : 'ゆるふわラブリーミントワンピ',
            imgUrl      : '/images/items/AM-114.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeCase',
            rare        : 'R',
          }),
          item({
            collection  : 'PriTickeCase',
            rare        : 'R',
          }),
          item({
            collection  : 'PriTickeCase',
            rare        : 'R',
          }),


          // [NOTE] ジュエルケース
          // ================================================================================

          item({
            collection  : 'JewelCase',
            id          : 'AM-115',
            rare        : 'R',
            name        : 'デニムリボンテディベアイエローワンピ',
            imgUrl      : '/images/items/AM-115.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JewelCase',
            id          : 'AM-116',
            rare        : 'R',
            name        : 'デニムリボンブルーパンプス',
            imgUrl      : '/images/items/AM-116.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JewelCase',
            rare        : 'R',
          }),
          item({
            collection  : 'JewelCase',
            rare        : 'R',
          }),


          // [NOTE] ジュエルパクト シャーベットピンク/エレガントパープル
          // ================================================================================

          item({
            collection  : 'JewelPact_SP_EP',
            id          : 'AM-108',
            rare        : 'SR',
            name        : 'ジュエルパクトワンピ',
            imgUrl      : '/images/items/AM-108.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JewelPact_SP_EP',
            id          : 'AM-109',
            rare        : 'SR',
            name        : 'ジュエルパクトシューズ',
            imgUrl      : '/images/items/AM-109.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JewelPact_SP_EP',
            id          : 'AM-110',
            rare        : 'SR',
            name        : 'ジュエルパクトヘアアクセ',
            imgUrl      : '/images/items/AM-110.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JewelPact_SP_EP',
            rare        : 'SR',
          }),


          // [NOTE] ジュエルパクト シャーベットピンク/エレガントパープル 早期購入特典
          // ================================================================================

          item({
            collection  : 'JewelPact_SP_EP_Early',
            id          : 'P-057',
            rare        : 'KR',
            name        : 'プレシャスミューズピンクキラッとワンピ',
            imgUrl      : '/images/items/P-057.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'PM',
            type        : 'PR',
            point       : 1570,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JewelPact_SP_EP_Early',
            id          : 'P-058',
            rare        : 'KR',
            name        : 'プレシャスミューズピンクキラッとシューズ',
            imgUrl      : '/images/items/P-058.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JewelPact_SP_EP_Early',
            id          : 'P-059',
            rare        : 'KR',
            name        : 'プレシャスミューズピンクキラッとヘアアクセ',
            imgUrl      : '/images/items/P-059.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JewelPact_SP_EP_Early',
            rare        : 'KR',
          }),


          // [NOTE] レインボージュエルパクト だいあDXセット
          // ================================================================================

          item({
            collection  : 'JewelPact_DaiaDX',
            id          : 'AM-273',
            rare        : 'SR',
            name        : 'ジュエルパクトスカイワンピ',
            imgUrl      : '/images/items/AM-273.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JewelPact_DaiaDX',
            id          : 'AM-274',
            rare        : 'SR',
            name        : 'ジュエルパクトスカイシューズ',
            imgUrl      : '/images/items/AM-274.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JewelPact_DaiaDX',
            rare        : 'SR',
          }),
          item({
            collection  : 'JewelPact_DaiaDX',
            rare        : 'SR',
          }),


          // [NOTE] デザインパレットジュエルピンク/ジュエルホワイト 早期購入特典
          // ================================================================================

          item({
            collection  : 'DP_JP_JW',
            id          : 'P-128',
            rare        : 'PR',
            name        : 'はあと♡パールみずいろワンピ',
            imgUrl      : '/images/items/P-128.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'CH',
            type        : 'LO',
            point       : 1500,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW',
            id          : 'P-129',
            rare        : 'PR',
            name        : 'はあと♡パールみずいろシューズ',
            imgUrl      : '/images/items/P-129.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW',
            id          : 'P-130',
            rare        : 'PR',
            name        : 'はあと♡パールみずいろヘアアクセ',
            imgUrl      : '/images/items/P-130.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW',
            rare        : 'PR',
          }),


          // [NOTE] デザインパレット ジュエルピンク/ジュエルホワイト トイザらス特典
          // ================================================================================

          item({
            collection  : 'DP_JP_JW_TZ',
            id          : 'P-152',
            rare        : 'SR',
            name        : 'ピクニックギンガムゴールドケープワンピ',
            imgUrl      : '/images/items/P-152.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_TZ',
            id          : 'P-153',
            rare        : 'SR',
            name        : 'ピクニックギンガムゴールドシューズ',
            imgUrl      : '/images/items/P-153.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_TZ',
            id          : 'P-154',
            rare        : 'SR',
            name        : 'ピクニックギンガムゴールドヘアアクセ',
            imgUrl      : '/images/items/P-154.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_TZ',
            rare        : 'SR',
          }),


          // [NOTE] デザインパレット ジュエルピンク/ジュエルホワイト イオン特典
          // ================================================================================

          item({
            collection  : 'DP_JP_JW_AE',
            id          : 'P-155',
            rare        : 'SR',
            name        : 'もりのおんがくたいフラワートップス',
            imgUrl      : '/images/items/P-155.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_AE',
            id          : 'P-156',
            rare        : 'SR',
            name        : 'もりのおんがくたいフラワースカート',
            imgUrl      : '/images/items/P-156.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_AE',
            id          : 'P-157',
            rare        : 'SR',
            name        : 'もりのおんがくたいフラワーシューズ',
            imgUrl      : '/images/items/P-157.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_AE',
            id          : 'P-158',
            rare        : 'SR',
            name        : 'もりのおんがくたいフラワーヘアアクセ',
            imgUrl      : '/images/items/P-158.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] デザインパレット ジュエルピンク/ジュエルホワイト イトーヨーカドー特典
          // ================================================================================

          item({
            collection  : 'DP_JP_JW_IY',
            id          : 'P-159',
            rare        : 'SR',
            name        : 'ブラック×ピンクチェックワンピ',
            imgUrl      : '/images/items/P-159.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_IY',
            id          : 'P-160',
            rare        : 'SR',
            name        : 'ブラック×ピンクチェックシューズ',
            imgUrl      : '/images/items/P-160.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_IY',
            id          : 'P-161',
            rare        : 'SR',
            name        : 'ブラック×ピンクチェックヘアアクセ',
            imgUrl      : '/images/items/P-161.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_IY',
            rare        : 'SR',
          }),


          // [NOTE] デザインパレット ジュエルピンク/ジュエルホワイト ユニー特典
          // ================================================================================

          item({
            collection  : 'DP_JP_JW_UN',
            id          : 'P-162',
            rare        : 'SR',
            name        : 'ロータスチャイナオレンジブラウス',
            imgUrl      : '/images/items/P-162.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_UN',
            id          : 'P-163',
            rare        : 'SR',
            name        : 'ロータスチャイナオレンジスカート',
            imgUrl      : '/images/items/P-163.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_UN',
            id          : 'P-164',
            rare        : 'SR',
            name        : 'ロータスチャイナオレンジシューズ',
            imgUrl      : '/images/items/P-164.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_UN',
            id          : 'P-165',
            rare        : 'SR',
            name        : 'ロータスチャイナオレンジヘアアクセ',
            imgUrl      : '/images/items/P-165.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] デザインパレット ジュエルピンク/ジュエルホワイト アマゾン特典
          // ================================================================================

          item({
            collection  : 'DP_JP_JW_AM',
            id          : 'P-166',
            rare        : 'SR',
            name        : 'クラブストライプレッドトップス',
            imgUrl      : '/images/items/P-166.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_AM',
            id          : 'P-167',
            rare        : 'SR',
            name        : 'クラブストライプレッドスカート',
            imgUrl      : '/images/items/P-167.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_AM',
            id          : 'P-168',
            rare        : 'SR',
            name        : 'クラブストライプレッドシューズ',
            imgUrl      : '/images/items/P-168.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_JP_JW_AM',
            id          : 'P-169',
            rare        : 'SR',
            name        : 'クラブストライプレッドヘアアクセ',
            imgUrl      : '/images/items/P-169.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] デザインパレット シャーベットピンク/エターナルホワイト 早期購入特典
          // ================================================================================

          item({
            collection  : 'DP_SP_EW',
            id          : 'P-097',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムらぁらアナザーワンピ',
            imgUrl      : '/images/items/P-097.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : '',
            type        : 'LO',
            point       : 1550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_SP_EW',
            id          : 'P-098',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムらぁらアナザーシューズ',
            imgUrl      : '/images/items/P-098.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_SP_EW',
            id          : 'P-099',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムらぁらアナザーヘアアクセ',
            imgUrl      : '/images/items/P-099.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_SP_EW',
            rare        : 'PR',
          }),


          item({
            collection  : 'DP_SP_EW',
            id          : 'P-100',
            rare        : 'KR',
            name        : 'ピュアプリンセスノワールキラッとワンピ',
            imgUrl      : '/images/items/P-100.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_SP_EW',
            id          : 'P-101',
            rare        : 'KR',
            name        : 'ピュアプリンセスノワールキラッとシューズ',
            imgUrl      : '/images/items/P-101.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_SP_EW',
            id          : 'P-102',
            rare        : 'KR',
            name        : 'ピュアプリンセスノワールキラッとヘアアクセ',
            imgUrl      : '/images/items/P-102.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DP_SP_EW',
            rare        : 'KR',
          }),


          // [NOTE] アニメDVD-BOX 3,4巻 初回特典
          // ================================================================================

          item({
            collection  : 'DVDBOX3-4',
            id          : 'P-075',
            rare        : 'SR',
            name        : 'ミラクルアイドルホワイトトップス',
            imgUrl      : '/images/items/P-075.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBOX3-4',
            id          : 'P-076',
            rare        : 'SR',
            name        : 'ミラクルアイドルホワイトスカート',
            imgUrl      : '/images/items/P-076.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBOX3-4',
            id          : 'P-077',
            rare        : 'SR',
            name        : 'ミラクルアイドルホワイトシューズ',
            imgUrl      : '/images/items/P-077.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBOX3-4',
            id          : 'P-078',
            rare        : 'SR',
            name        : 'ミラクルアイドルホワイトヘアアクセ',
            imgUrl      : '/images/items/P-078.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] アニメDVD-BOX 5,6巻 初回特典
          // ================================================================================

          item({
            collection  : 'DVDBOX5-6',
            id          : 'P-148',
            rare        : 'SR',
            name        : 'ホーンテッドヴァンパイアブルーパープルトップス',
            imgUrl      : '/images/items/P-148.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBOX5-6',
            id          : 'P-149',
            rare        : 'SR',
            name        : 'ホーンテッドヴァンパイアブルーパープルスカート',
            imgUrl      : '/images/items/P-149.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBOX5-6',
            id          : 'P-150',
            rare        : 'SR',
            name        : 'ホーンテッドヴァンパイアブルーパープルシューズ',
            imgUrl      : '/images/items/P-150.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBOX5-6',
            id          : 'P-151',
            rare        : 'SR',
            name        : 'ホーンテッドヴァンパイアブルーパープルヘアアクセ',
            imgUrl      : '/images/items/P-151.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] GAME Pri☆chan Music Collection vol.1
          // [TODO] 所持しているはず。行方不明になっている。探索必要。
          // ================================================================================

          item({
            collection  : 'GamePriChanCD1',
            id          : 'P-079',
            rare        : 'SR',
            name        : 'ハートフルバレンタインホワイトトップス',
            imgUrl      : '/images/items/P-079.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriChanCD1',
            id          : 'P-080',
            rare        : 'SR',
            name        : 'ハートフルバレンタインホワイトスカート',
            imgUrl      : '/images/items/P-080.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriChanCD1',
            id          : 'P-081',
            rare        : 'SR',
            name        : 'ハートフルバレンタインホワイトシューズ',
            imgUrl      : '/images/items/P-081.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriChanCD1',
            id          : 'P-082',
            rare        : 'SR',
            name        : 'ハートフルバレンタインホワイトヘアアクセ',
            imgUrl      : '/images/items/P-082.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] GAME Pri☆chan Music Collection vol.2
          // ================================================================================

          item({
            collection  : 'GamePriChanCD2',
            id          : 'P-118',
            rare        : 'R',
            name        : 'もりのおんがくたいサニートップス',
            imgUrl      : '/images/items/P-118.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriChanCD2',
            id          : 'P-119',
            rare        : 'R',
            name        : 'もりのおんがくたいサニースカート',
            imgUrl      : '/images/items/P-119.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriChanCD2',
            id          : 'P-120',
            rare        : 'R',
            name        : 'もりのおんがくたいサニーシューズ',
            imgUrl      : '/images/items/P-120.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriChanCD2',
            id          : 'P-121',
            rare        : 'R',
            name        : 'もりのおんがくたいサニーヘアアクセ',
            imgUrl      : '/images/items/P-121.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] GAME PriPara BEST
          // ================================================================================

          item({
            collection  : 'GamePriParaBest',
            id          : 'P-187',
            rare        : 'SR',
            name        : 'ドリームパレードプリンスドレス',
            imgUrl      : '/images/items/P-187.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriParaBest',
            id          : 'P-188',
            rare        : 'SR',
            name        : 'ドリームパレードプリンスシューズ',
            imgUrl      : '/images/items/P-188.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriParaBest',
            id          : 'P-189',
            rare        : 'SR',
            name        : 'ドリームパレードプリンスヘアアクセ',
            imgUrl      : '/images/items/P-189.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriParaBest',
            rare        : 'SR',
          }),

        ]
      }
    },

    methods: {
      collection (collection = '') {
        return _.where(this.items, { collection })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="みらいのプリチケバッグ" color="#feab0d" :items="collection('PriTicketBag_Mirai')" />
      <ItemList title="プリ☆チャンファイル|だいあ＆キラッツ" color="#feab0d" :items="collection('PrichanFile_Daia_Kirats')" />
      <ItemList title="プリ☆チャンファイル|リングマリィ" color="#feab0d" :items="collection('PrichanFile_RingMarry')" />
      <ItemList title="プリ☆チャンファイル|オールアイドル" color="#feab0d" :items="collection('PrichanFile_AllIdol')" />
      <ItemList title="プリチケケース" color="#feab0d" :items="collection('PriTickeCase')" />
      <ItemList title="ジュエルケース" color="#feab0d" :items="collection('JewelCase')" />
    </template>

    <template #col2>
      <ItemList title="ジュエルパクト|シャーベットピンク/エレガントパープル" color="#00c7da" :items="collection('JewelPact_SP_EP')" />
      <ItemList title="ジュエルパクト|シャーベットピンク/エレガントパープル|早期購入特典" color="#ff5d91" :items="collection('JewelPact_SP_EP_Early')" />
      <ItemList title="レインボージュエルパクト|だいあDXセット" color="#feab0d" :items="collection('JewelPact_DaiaDX')" />
      <ItemList title="デザインパレット|ジュエルピンク/ジュエルホワイト|早期購入特典" color="#ffa1bc" :items="collection('DP_JP_JW')" />
      <ItemList title="デザインパレット|シャーベットピンク/エターナルホワイト|早期購入特典" color="#ff5d91" :items="collection('DP_SP_EW')" />
    </template>

    <template #col3>
      <ItemList title="デザインパレット|ジュエルピンク/ジュエルホワイト|トイザらス特典" color="#00c7da" :items="collection('DP_JP_JW_TZ')" />
      <ItemList title="デザインパレット|ジュエルピンク/ジュエルホワイト|イオン特典" color="#00c7da" :items="collection('DP_JP_JW_AE')" />
      <ItemList title="デザインパレット|ジュエルピンク/ジュエルホワイト|イトーヨーカドー特典" color="#00c7da" :items="collection('DP_JP_JW_IY')" />
      <ItemList title="デザインパレット|ジュエルピンク/ジュエルホワイト|ユニー特典" color="#00c7da" :items="collection('DP_JP_JW_UN')" />
      <ItemList title="デザインパレット|ジュエルピンク/ジュエルホワイト|アマゾン特典" color="#00c7da" :items="collection('DP_JP_JW_AM')" />
    </template>

    <template #col4>
      <ItemList title="アニメDVD-BOX 3, 4巻|初回特典" color="#00c7da" :items="collection('DVDBOX3-4')" />
      <ItemList title="アニメDVD-BOX 5, 6巻|初回特典" color="#00c7da" :items="collection('DVDBOX5-6')" />
      <ItemList title="GAME Pri☆chan Music Collection|vol.1" color="#00c7da" :items="collection('GamePriChanCD1')" />
      <ItemList title="GAME Pri☆chan Music Collection|vol.2" color="#feab0d" :items="collection('GamePriChanCD2')" />
      <ItemList title="GAME PriPara BEST" color="#00c7da" :items="collection('GamePriParaBest')" />
      <Status :date="date" :items="items" />
    </template>

    <template #col5>
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    // right: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
